/**
 * This file is part of Magestore POS Open Source.
 *
 * Magestore POS Open Source is free software: you can redistribute it
 * and/or modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation, either version 3
 * of the License, or (at your option) any later version.
 *
 * Magestore POS Open Source is distributed in the hope that it will
 * be useful, but WITHOUT ANY WARRANTY; without even the implied warranty
 * of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along
 * with Magestore POS Open Source. If not, see <https://www.gnu.org/licenses/>
 */ 
export default {
    ENTER_KEY: 'Enter',
    MAX_DIFF_TIME_WITH_SCAN_BARCODE: 100,
    BARCODE_CONFIG: 'webpos/product_search/barcode',
    ADDITIONAL_ATTRIBUTES_ON_GRID_CONFIG: 'webpos/product_search/additional_attributes_on_grid',
}



// WEBPACK FOOTER //
// ./src/view/constant/SearchConstant.js